<template>
  <div>
      <nav class="bar bar-nav">
        <a class="button button-link button-nav pull-left"  @click="tolast()">
          <span class="icon icon-left"></span>返回
        </a>
        <div class="button button-link button-nav pull-right" >
          <a href="http://genechem-customer.xinfuli.net/web/login">积分兑换 </a>
        </div>
      </nav>

    <div class="content" style="margin-bottom: 3rem">
      <div style="text-align: center;font-size: larger">积分详情</div>
      <div style="float: right;margin-right: 10px"><i class="icon icon-star"></i> 总剩余积分-- {{totalRemainPoints}} </i></div>
      <div style="float: left;margin-left: 10px"><i class="icon icon-star"></i> 总积分-- {{totalPoints}} </i></div>
      <div class="list-block cards-list" v-for="points in pointsList " style="margin-top: 30px">
        <ul >
          <li class="card">
            <div class="card-header" style="font-size: smaller">
              <span>合同号- {{points.contractNo}}</span>
              <span v-if="new Date() > new Date(Date.parse(points.validUntil))">
               <div>
                <img src="/emktResources/resocurces/img/endused_img.jpg" style="height: 50px;width: 70px">
              </div>
              </span>
              <span v-else>是否到期: 否</span>
            </div>

            <div class="card-content">
              <div class="card-content-inner" style="margin-bottom: 25px">
                <div>
               <div style="float: left">
                 积分数量-- {{points.accruedPoint}}
               </div>
                  <div style="float: right;">
               剩余积分-- {{points.remainedPoint}}
               </div>
                </div>
              </div>
            </div>
            <div class="card-footer" style="font-size: smaller">
              <span>
                计入时间- {{points.activateDT.substring(0,10)}}
              </span>
              <span>
               到期时间- {{points.validUntil}}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
//  import $ from 'jquery'
  import {mapState} from 'vuex'
  export default {
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    data () {
      return {
        pointsList: [],
        totalPoints: 0,
        totalRemainPoints: 0
      }
    },
    methods: {
      fetchData () {
        var param = {
          'customerNo': this.sessionInfo.customerInfo.customerNo
        }
        this.gcapi('gcwwwifc/pointsDetails', param).then((response) => {
          this.pointsList = response.body.result
          var points = 0
          var points1 = 0
          this.pointsList.forEach(function (item) {
            if (new Date() < new Date(Date.parse(item.validUntil))) {
              console.log(item.remainedPoint)
              points = points + item.remainedPoint
              points1 = points1 + item.accruedPoint
            }
          })
          this.totalPoints = points1
          this.totalRemainPoints = points
        })
      },
      tolast () {
        this.$router.go(-1)
      }
    }
  }
</script>


<style scoped>
  .item-inner {
    padding-bottom: 0rem
  }
</style>



// WEBPACK FOOTER //
// PointsDetails.vue?c1045e0a